<template>
  <v-navigation-drawer
    absolute
    right
    :overlay-opacity="0"
    temporary
    v-model="showFilter"
  >
    <v-toolbar
      flat
      :color="$vuetify.theme.dark ? '#1E1E1E' : 'white'"
    >
      <v-toolbar-title>
        Recipe filters
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="toggleFilter">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card flat>
      <perfect-scrollbar>
        <v-card-text style="height:calc(100vh - 220px)">
          <v-autocomplete
            v-model="lines"
            :items="lineList"
            outlined
            dense
            hide-details
            return-object
            item-text="name"
            :label="this.$t('Select Line')"
            @change="onChangeLine(lines)"
          ></v-autocomplete>
          <div class="subheading font-weight-regular mt-4"></div>
          <v-autocomplete
            v-model="sublines"
            :items="subLineList"
            outlined
            dense
            hide-details
            return-object
            item-text="name"
            :label="this.$t('Select Subline')"
            @change="onChangeSubLine(sublines)"
          ></v-autocomplete>
          <div class="subheading font-weight-regular mt-4"></div>
          <v-autocomplete
            v-model="stations"
            :items="stationList"
            outlined
            dense
            hide-details
            return-object
            item-text="name"
            :label="this.$t('Select Station')"
            @change="onChangeStation(stations)"
          ></v-autocomplete>
          <div class="subheading font-weight-regular mt-4"></div>
          <v-autocomplete
            v-model="recipes"
            :items="recipeNames"
            outlined
            dense
            hide-details
            return-object
            item-text="recipename"
            :label="this.$t('Select Recipe name')"
            @change="onChangeRecipe(recipes)"
          ></v-autocomplete>
        </v-card-text>
      </perfect-scrollbar>
      <v-card-actions>
        <v-btn
          class="text-none"
          color="primary"
          @click="btnApply"
          :class="$vuetify.theme.dark ? 'black--text' : 'white--text'"
        >
          Apply
        </v-btn>
        <v-btn class="text-none" color="primary" @click="btnReset" text>Reset</v-btn>
      </v-card-actions>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'RecipeFilter',
  async created() {
    await this.getRecipeNameByStation('');
  },
  data() {
    return {
      lines: null,
      sublines: null,
      stations: null,
      recipes: null,
    };
  },
  watch: {
    filterLine: {
      handler(val) {
        this.lines = val;
      },
      deep: true,
    },
    filterSubLine: {
      handler(val) {
        this.sublines = val;
      },
      deep: true,
    },
    filterStation: {
      handler(val) {
        this.stations = val;
      },
      deep: true,
    },
    filterRecipe: {
      handler(val) {
        this.recipes = val;
      },
      deep: true,
    },
  },
  computed: {
    ...mapState('recipeManagement', ['recipeList', 'filter', 'lineList', 'subLineList', 'stationList', 'filterBList', 'subStationList', 'recipeNames', 'filterLine', 'filterStation', 'filterSubLine', 'filterRecipe']),
    showFilter: {
      get() {
        return this.filter;
      },
      set(val) {
        this.setFilter(val);
      },
    },
  },
  methods: {
    ...mapActions('recipeManagement', ['getRecipeListRecords', 'getSubLines', 'getStations', 'getSubStations', 'getRecipeNameByStation']),
    ...mapMutations('recipeManagement', ['setFilter', 'toggleFilter', 'setFilterLine', 'setFilterSubLine', 'setFilterStation', 'setRecipeList', 'setFilterRecipe']),
    async onChangeLine(val) {
      const query = `?query=lineid==${val.id}`;
      await this.getSubLines(query);
      this.setFilterLine(this.lines);
    },
    async onChangeSubLine(val) {
      const query = `?query=sublineid=="${val.id}"`;
      await this.getStations(query);
      this.setFilterSubLine(this.sublines);
    },
    async onChangeStation(val) {
      const query = `?query=stationid=="${val.id}"`;
      await this.getRecipeNameByStation(query);
      this.setFilterStation(this.stations);
    },
    onChangeRecipe() {
      this.setFilterRecipe(this.recipes);
    },
    async btnApply() {
      let query = '?query=';
      if (this.lines && this.lines.id) {
        this.setFilterLine(this.lines);
        query += `lineid=="${this.lines.id}"`;
      }
      if (this.sublines && this.sublines.id) {
        this.setFilterSubLine(this.sublines);
        if (query === '?query=') {
          query += `sublineid=="${this.sublines.id}"`;
        } else {
          query += `%26%26sublineid=="${this.sublines.id}"`;
        }
      }
      if (this.stations && this.stations.id) {
        this.setFilterStation(this.stations);
        if (query === '?query=') {
          query += `stationid=="${this.stations.id}"`;
        } else {
          query += `%26%26stationid=="${this.stations.id}"`;
        }
      }
      if (this.recipes && this.recipes.recipenumber) {
        this.setFilterRecipe(this.recipes);
        if (query === '?query=') {
          query += `recipenumber=="${this.recipes.recipenumber}"`;
        } else {
          query += `%26%26recipenumber=="${this.recipes.recipenumber}"`;
        }
      }
      await this.getRecipeListRecords(query);
      this.toggleFilter();
    },
    async btnReset() {
      await this.getRecipeListRecords('');
      // this.setRecipeList(this.filterBList);
      this.$root.$emit('filteredSubline', null);
      this.$root.$emit('filteredStation', null);
      this.lines = '';
      this.sublines = '';
      this.stations = '';
      this.recipes = '';
      this.setFilterLine(this.lines);
      this.setFilterSubLine(this.sublines);
      this.setFilterStation(this.stations);
      this.setFilterRecipe(this.recipes);
      this.toggleFilter();
    },
  },
  async beforeDestroy() {
    this.lines = '';
    this.sublines = '';
    this.stations = '';
    this.recipes = '';
  },
};
</script>
